import React, { useEffect } from 'react';
import { PubsubChannelType, UniqueVisitor } from 'sb-lib/types';
import { useAppDispatch, useAppSelector } from 'shared/store';
import { setConversationRead } from 'shared/store/conversation-slice';
import { fetchMoreChatMessages, clearChatMessages } from 'shared/store/chat-slice';
import { useSocketSubscription } from 'shared/hooks';
import { SessionChatMessages } from 'shared/components/SessionChatMessages';
import { SessionChatFooter } from 'shared/components/SessionChatFooter';
import { SessionChatAfterFooter } from 'shared/components/SessionChatAfterFooter';
import './style.less';

interface SessionChatProps {
  visitor: UniqueVisitor;
  size: 'default' | 'collapsed';
  openConversation: (visitorId: string, conversationId: number) => void;
  handleImageChange: (event: React.ChangeEvent<HTMLInputElement>) => Promise<void>;
}

export const SessionChat: React.FC<SessionChatProps> = ({
  visitor,
  size,
  handleImageChange,
}) => {
  const appDispatch = useAppDispatch();
  const { conversation } = useAppSelector(s => s.conversation);

  useEffect(() => {
    if (visitor.id && conversation?.id && conversation.visitor.id === visitor.id) {
      appDispatch(
        fetchMoreChatMessages({ visitorId: visitor.id, conversationId: conversation.id }),
      );
    }
    return () => {
      appDispatch(clearChatMessages());
    };
  }, [appDispatch, visitor.id, conversation?.id, conversation?.visitor]);

  useSocketSubscription(
    PubsubChannelType['chat.conversation'],
    conversation?.id.toString(),
    true,
  );

  useEffect(() => {
    if (conversation?.id && size === 'default') {
      void appDispatch(setConversationRead({ conversationId: conversation?.id }));
    }
  }, [appDispatch, conversation?.id, size]);

  if (!conversation) return null;

  return (
    <>
      <SessionChatMessages visitor={visitor} isChatCollapsed={size === 'collapsed'} />
      <SessionChatFooter
        visitor={visitor}
        size={size}
        handleImageChange={handleImageChange}
        autoFocus
      />
      <SessionChatAfterFooter />
    </>
  );
};
